export default __webpack_public_path__ + "static/media/section2-2-img1.5a6d747e.png";